import { ShipmentType } from '../enums/shipment-type';
import { ShipmentWithNotifications } from './shipment-delivery-schedule';

export class TruckWithNotifications extends ShipmentWithNotifications {
    constructor() {
        super(ShipmentType.Truck);
    }
}
